import { ActionCreatorProps, createAction, props } from '@ngrx/store';
import { IDatiqAnalyticsEvent } from '@dat/datiq-core/models';

const createActionName: (name: string) => string = (name: string) => {
    return `[Datiq Modal] ${name}`;
};
const defaultAnalyticProps: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();

export const clickedCloseButtonName: string = createActionName(
    'clicked close button'
);
export const clickedClosedButton = createAction(
    clickedCloseButtonName,
    defaultAnalyticProps
);

export const openedName: string = createActionName('modal opened');
export const opened = createAction(openedName, defaultAnalyticProps);
